import {
    ACOES,
    CONDICOES,
    type CondicaoId,
    isAcaoId,
    isCondicaoAlcance,
    isCondicaoId,
    type Rotina,
} from '@acme/core'
import { CONDICOES_UI } from '../condicoes'
import { rotuloCondicao } from './ordem'

/** Resume as condições da rotina numa frase — "Exceto local e falta ou sem abono". */
export function resumirCondicoes(condicoes: Rotina['condicoes']): string {
    return condicoes
        .map(({ condicaoId, ocorre }, index) => {
            const termo = descreverCondicao(condicaoId, ocorre)
            if (index === 0) return termo

            return `${rotuloCondicao(condicoes, index)} ${termo.toLowerCase()}`
        })
        .join(' ')
}

/** Nome da condição com a negação — "Sem abono", "Exceto local". */
export function descreverCondicao(condicaoId: string, ocorre: boolean): string {
    const label = isCondicaoId(condicaoId)
        ? CONDICOES[condicaoId].label
        : condicaoId
    if (ocorre) return label

    const termo = label.toLowerCase()
    return isCondicaoAlcance(condicaoId) ? `Exceto ${termo}` : `Sem ${termo}`
}

/** Resume as ações da rotina, na ordem de execução, separadas por vírgula. */
export function resumirAcoes(acoes: Rotina['acoes']): string {
    return acoes
        .map(({ acaoId }) => (isAcaoId(acaoId) ? ACOES[acaoId].label : acaoId))
        .join(', ')
}

/** Resume os parâmetros da condição numa linha; sem parâmetros, usa a descrição do catálogo. */
export function resumirParametrosCondicao(
    condicaoId: CondicaoId,
    parametros: Record<string, unknown>,
): string {
    const { resumir } = CONDICOES_UI[condicaoId]
    return resumir ? resumir(parametros) : CONDICOES[condicaoId].descricao
}
